module.exports = __webpack_public_path__ + "static/back_event_01-33d01fc2df0f96d95ac84625307b4f08.jpg";